import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Nav.css';

const links = [
  { to: '/', label: 'Tools' },
  { to: '/sku-family-live', label: 'SKU Family Inv' },
  { to: '/inventory-management', label: 'Inventory Mgmt' },
  { to: '/draft-orders', label: 'Draft Orders' },
  { to: '/location-orders', label: 'Order by Location' },
  { to: '/packiyo-ordering', label: 'Packiyo Orders' },
  { to: '/order-matrix', label: 'Order Matrix' },
  { to: '/kpi-report', label: 'KPI Report' },
  { to: '/markitdown', label: 'PDF to Markdown' },
  { to: '/wiki', label: 'Wiki' },
  { to: '/wholesale/applications', label: 'Wholesale' },
];

export default function Nav({ user }) {
  const { pathname } = useLocation();
  return (
    <nav className="nav">
      <span className="nav-brand">Heavy Play</span>
      <div className="nav-links">
        {links.map(l => (
          <Link key={l.to} to={l.to}
            className={pathname === l.to || (l.to !== '/' && pathname.startsWith(l.to)) ? 'active' : ''}>
            {l.label}
          </Link>
        ))}
      </div>
      {user && !user.auth_disabled && (
        <div className="nav-user">
          {user.picture && <img src={user.picture} alt="" className="nav-avatar" referrerPolicy="no-referrer" />}
          <span className="nav-name">{user.name || user.email}</span>
          <a href="/auth/logout" className="nav-logout">Sign out</a>
        </div>
      )}
    </nav>
  );
}
